"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.collapsable = exports.size = exports.base = exports.background = exports.spaceFill = exports.root = exports.scroll = exports.clipped = exports.borders = exports.spacing = void 0;
const styled_components_1 = require("styled-components");
const types_1 = require("./types");
const spacing = ({ theme, indentLeft, indentTop, indentRight, indentBottom, indentAll, indentHorizontal, indentVertical, spaceLeft, spaceTop, spaceRight, spaceBottom, spaceAll, spaceHorizontal, spaceVertical }) => (0, styled_components_1.css) `
    ${indentAll &&
    (0, styled_components_1.css) `
        margin-left: ${theme.spacing[indentAll]};
        margin-top: ${theme.spacing[indentAll]};
        margin-right: ${theme.spacing[indentAll]};
        margin-bottom: ${theme.spacing[indentAll]};
    `};
    ${indentHorizontal &&
    (0, styled_components_1.css) `
        margin-left: ${theme.spacing[indentHorizontal]};
        margin-right: ${theme.spacing[indentHorizontal]};
    `};
    ${indentVertical &&
    (0, styled_components_1.css) `
        margin-top: ${theme.spacing[indentVertical]};
        margin-bottom: ${theme.spacing[indentVertical]};
    `};
    ${indentLeft &&
    (0, styled_components_1.css) `
        margin-left: ${theme.spacing[indentLeft]};
    `};
    ${indentTop &&
    (0, styled_components_1.css) `
        margin-top: ${theme.spacing[indentTop]};
    `};
    ${indentRight &&
    (0, styled_components_1.css) `
        margin-right: ${theme.spacing[indentRight]};
    `};
    ${indentBottom &&
    (0, styled_components_1.css) `
        margin-bottom: ${theme.spacing[indentBottom]};
    `};
    ${spaceAll &&
    (0, styled_components_1.css) `
        padding-left: ${theme.spacing[spaceAll]};
        padding-top: ${theme.spacing[spaceAll]};
        padding-right: ${theme.spacing[spaceAll]};
        padding-bottom: ${theme.spacing[spaceAll]};
    `};
    ${spaceHorizontal &&
    (0, styled_components_1.css) `
        padding-left: ${theme.spacing[spaceHorizontal]};
        padding-right: ${theme.spacing[spaceHorizontal]};
    `};
    ${spaceVertical &&
    (0, styled_components_1.css) `
        padding-top: ${theme.spacing[spaceVertical]};
        padding-bottom: ${theme.spacing[spaceVertical]};
    `};
    ${spaceLeft &&
    (0, styled_components_1.css) `
        padding-left: ${theme.spacing[spaceLeft]};
    `};
    ${spaceTop &&
    (0, styled_components_1.css) `
        padding-top: ${theme.spacing[spaceTop]};
    `};
    ${spaceRight &&
    (0, styled_components_1.css) `
        padding-right: ${theme.spacing[spaceRight]};
    `};
    ${spaceBottom &&
    (0, styled_components_1.css) `
        padding-bottom: ${theme.spacing[spaceBottom]};
    `};
`;
exports.spacing = spacing;
const borders = ({ theme, borderAll, borderLeft, borderTop, borderRight, borderBottom }) => (borderAll || borderLeft || borderTop || borderRight || borderBottom) &&
    (0, styled_components_1.css) `
        position: relative;
        ${borderAll &&
        (0, styled_components_1.css) `
            border: 1px solid
                ${borderAll === types_1.VIEW_BORDER.none
            ? 'rgba(0, 0, 0, 0)'
            : theme.colors.borders[borderAll]};
        `}
        ${borderLeft &&
        (0, styled_components_1.css) `
            border-left: 1px solid
                ${borderLeft === types_1.VIEW_BORDER.none
            ? 'rgba(0, 0, 0, 0)'
            : theme.colors.borders[borderLeft]};
        `}
    ${borderTop &&
        (0, styled_components_1.css) `
            border-top: 1px solid
                ${borderTop === types_1.VIEW_BORDER.none
            ? 'rgba(0, 0, 0, 0)'
            : theme.colors.borders[borderTop]};
        `}
    ${borderRight &&
        (0, styled_components_1.css) `
            border-right: 1px solid
                ${borderRight === types_1.VIEW_BORDER.none
            ? 'rgba(0, 0, 0, 0)'
            : theme.colors.borders[borderRight]};
        `}
    ${borderBottom &&
        (0, styled_components_1.css) `
            border-bottom: 1px solid
                ${borderBottom === types_1.VIEW_BORDER.none
            ? 'rgba(0, 0, 0, 0)'
            : theme.colors.borders[borderBottom]};
        `}
    `;
exports.borders = borders;
const clipped = ({ clipped }) => clipped &&
    (0, styled_components_1.css) `
        overflow-x: hidden;
        overflow-y: hidden;
    `;
exports.clipped = clipped;
const scroll = ({ hasYScroll, hasXScroll }) => (0, styled_components_1.css) `
    ${hasYScroll &&
    (0, styled_components_1.css) `
        overflow-y: auto;
    `}
    ${hasXScroll &&
    (0, styled_components_1.css) `
        overflow-x: auto;
    `}
`;
exports.scroll = scroll;
const root = ({ root }) => root &&
    (0, styled_components_1.css) `
        position: relative;
    `;
exports.root = root;
const spaceFill = ({ spaceFill }) => spaceFill === types_1.SPACE_FILL.all &&
    (0, styled_components_1.css) `
        flex: 1 1 100%;
        align-self: stretch;
    `;
exports.spaceFill = spaceFill;
const background = ({ theme, backgroundView }) => {
    return (0, styled_components_1.css) `
        background-color: ${backgroundView
        ? theme.colors.backgrounds[backgroundView]
        : 'transparent'};
    `;
};
exports.background = background;
exports.base = (0, styled_components_1.css) `
    display: flex;
    box-sizing: border-box;
    flex-shrink: 0;
    flex-wrap: wrap;
    min-width: 0;
    z-index: 1;
    outline: 0;
    overflow-x: visible;
    overflow-y: visible;
    &:after {
        z-index: 0;
    }
    &:before {
        z-index: 0;
    }
    & > * {
        z-index: 1;
    }
`;
const size = ({ size }) => (0, styled_components_1.css) `
    ${(size === null || size === void 0 ? void 0 : size.width) && `width: ${size.width}`};
    ${(size === null || size === void 0 ? void 0 : size.height) && `height: ${size.height}`};
`;
exports.size = size;
const collapsable = ({ collapsable }) => collapsable &&
    (0, styled_components_1.css) `
        flex-shrink: 1;
    `;
exports.collapsable = collapsable;
//# sourceMappingURL=styles.js.map